import $ from 'jquery';
import componentManager from 'app/module46/component-manager.js';

function setupToggleButton(component, name) {

	const $component = $(component);
	const $body = $('body');
	const selector = '.admin-bar__button--' + name;
	const className = 'show-' + name;
	const keyName = 'admin-bar.show-' + name;

	$component.find(selector).click(() => {

		const value = localStorage.getItem(keyName) !== 'true';
		localStorage.setItem(keyName, value);
		
		if (value) $body.addClass(className);
		else $body.removeClass(className);
	});

	if (localStorage.getItem(keyName) === 'true') {
		$body.addClass(className);
	}
}

componentManager.register('admin-bar', (component, elements) => {

	const $component = $(component);
	const $elementToPad = $('body, #menu-mobile');
	const $window = $(window);
	const {
		$resolution
	} = elements;

		$window.resize(() => {
			if (typeof($resolution) !== 'undefined'){
				$resolution.text($window.innerWidth() + 'x' + $window.innerHeight());
			}
		}).resize();

	setupToggleButton(component, 'guides');
});